export default "/images/vendor/flag-icons/flags/4x3/ph.svg?e215bab6b405d1afeff4e809f488ec41";